import { ModuleStatus } from 'types/domain/module';

/**
 * Turning a module into a template also makes it public: the server copies its
 * media to the public bucket the first time `public` goes to 1, which is what
 * lets another org's Examples gallery play it. Turning it off leaves the copy.
 *
 * Its own file so ModuleShare can use it without importing ModuleSettings, which
 * closes an import cycle through the course selectors.
 */
export const templateChange = (checked: boolean) =>
  checked ? { status: ModuleStatus.TEMPLATE, public: 1 } : { status: ModuleStatus.ACTIVE };
